"use client";

import React from "react";
import Link from "next/link";
import { useCxcRegistrationStatus } from "@/constants/cxcRegistrationConfig";
import { ArrowRight } from "lucide-react";
import styles from "./CxcHeaderHighlight.module.css";

const CxcAnnouncementBanner: React.FC = () => {
  // Null until the server answers, so the banner never flashes on a closed site.
  const status = useCxcRegistrationStatus();

  if (!status || !status.isOpen) {
    return null;
  }

  return (
    <aside className={styles.cxcAnnouncementBar} role="banner" aria-label="CXC Admission Announcement">
      <Link href="/cxc-registration" className={styles.announcementLink}>
        <div className={styles.announcementContent}>
          <div className={styles.announcementBadge}>
            <span className={styles.liveBlinkWrapper} aria-hidden="true">
              <span className={styles.liveBlinkDot} />
              <span className={styles.liveBlinkRing} />
            </span>
            <span>Admission Open</span>
          </div>
          <span className={styles.announcementText}>
            CXC {status.activeBadgeText} Registration
          </span>
          <span className={styles.announcementBtn}>
            <span>Apply Online</span>
            <ArrowRight size={13} className={styles.btnArrow} />
          </span>
        </div>
      </Link>
    </aside>
  );
};

export default CxcAnnouncementBanner;
